import React, { useState, useEffect } from "react";
import ApexCharts from "apexcharts";
import Chart from "react-apexcharts";
const Reserve = (props) => {
  const { setReserved } = props;
  const [category, setCategory] = useState(props.xaxis);

  useEffect(() => {
    setCategory(props.xaxis);
  }, [props.xaxis]);
  useEffect(() => {
    ApexCharts.exec("chart", "dataURI")
      .then(({ imgURI, blob }) => {
        setReserved(imgURI);
      })
      .catch((error) => {
        console.log(error);
      });
  }, [props]);
  return (
    <Chart
      options={{
        chart: {
          id: "chart",
          height: 350,
          type: "line",
          dropShadow: {
            enabled: true,
            color: "#000",
            top: 18,
            left: 7,
            blur: 10,
            opacity: 0.2,
          },
          toolbar: {
            show: true,
            tools: {
              reset: true,
              pan: false,
            },
          },
        },
        dataLabels: {
          enabled: true,
          formatter: function (val, opts) {
            return "$" + val.toFixed(2);
          },
          style: {
            fontSize: "14px",
            fontFamily: "Helvetica, Arial, sans-serif",

            colors: undefined,
          },
        },
        tooltip: {
          enabled: true,
          enabledOnSeries: true,
          shared: false,
          followCursor: false,

          theme: false,
          style: {
            fontSize: "12px",
            fontFamily: undefined,
          },
          onDatasetHover: {
            highlightDataSeries: false,
          },
          x: {
            show: true,

            formatter: undefined,
          },
          y: {
            show: false,
            formatter: undefined,
            title: {
              formatter: (seriesName) => seriesName,
            },
          },

          marker: {
            show: false,
          },
          items: {
            display: "flex",
          },
          fixed: {
            enabled: false,
            position: "topRight",
            offsetX: 0,
            offsetY: 0,
          },
        },
        stroke: {
          curve: "smooth",
        },
        title: {
          text: props.title + " Reserves",
          align: "left",
        },
        grid: {
          borderColor: "#e7e7e7",
          row: {
            colors: ["#f3f3f3", "transparent"],
            opacity: 0.5,
          },
        },
        markers: {
          size: 5,
        },
        xaxis: {
          type: "category",
          categories: props.xaxis,
        },
        yaxis: {
          title: {
            text: "",
          },
          labels: {
            formatter: function (value) {
              return "$" + value.toFixed(2);
            },
          },
        },
        legend: {
          show: false,
        },
      }}
      series={[
        {
          name: "Pre-Load",
          data: props.reservepreload1,
        },
        {
          name: "Reserve",
          data: props.reservepreload2,
        },
        {
          name: "Sold",
          data: props.reserveSold1,
        },
        {
          name: "Reserve",
          data: props.reserveSold2,
        },
      ]}
      type="line"
      height={350}
    />
  );
};

export default Reserve;
